import { render, staticRenderFns } from "./LuckyTurn.vue?vue&type=template&id=d01c0f00&"
import script from "./LuckyTurn.vue?vue&type=script&lang=js&"
export * from "./LuckyTurn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports